import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect, useRef } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete, MdOutlineDeleteOutline } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dropdown, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { FiPlusCircle } from "react-icons/fi";
import { IoSearchOutline } from 'react-icons/io5';
import {
    deleteHsn,
    getHsn,
    partyDropdown,
    productDropdown,
    searchHsn,
    updateHsn,
} from '../../../redux/actions/Master.action';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { batchDropdown } from '../../../redux/actions/Admin.action';
import { addPurchaseReturn, getPurchaseReturnBill, updatePurchaseReturnBill, deletePurchaseReturnBill, viewPurchaseReturnBill } from '../../../redux/actions/Billing.action';
import { VscTarget } from 'react-icons/vsc';

export default function PurchaseReturn() {
    const inputRefs = useRef([]);
    const [show, setShow] = useState(false);
    const [viewModal, setViewModal] = useState(false)
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [ids, setIds] = useState(null);
    const [mainPage, setMainPage] = useState('1');
    const [searchProduct, setSearchProduct] = useState('');
    const [dropdownValues, setDropdownValues] = useState({
        partyName: '',
        taxType: '',
        gstApply: '',
        invoiceType: '',
        productName: ''
    });
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        page: '',
        search: '',
    });

    const [initialValues, setInitialValues] = useState({
        // hsnCode: '',
        // gst: ''
    });

    const validationSchema = Yup.object().shape({
        // hsnCode: Yup.string().required('HSN Code is required'),
        // gst: Yup.string().required('GST is required'),
    });
    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const purchaseData = useSelector((state) => state.master);
    const billData = useSelector((state) => state.bills);
    const dropdown = useSelector((state) => state.admin)
    console.log('dropdown', dropdown);
    console.log('purchaseData', purchaseData);
    console.log('billData', billData);

    const [formData, setFormData] = useState({
        partyId: '',
        partyName: '',
        taxType: '',
        dnType: '',
        gstApply: '',
        returnDate: '',
        productList: [{
            productId: '',
            productName: '',
            pack: '',
            hsnCode: '',
            batchNo: '',
            mrp: '',
            expDate: '',
            qty: '',
            freeQty: '',
            dnRate: '',
            gst: ''
        }],
        remark: '',
        basicAmount: '',
        discount: '',
        sgst: '',
        cgst: '',
        otherAmount: '',
        roundingAmount: '',
        dnAmount: '',
    });

    console.log('formData---', formData);


    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const handleDropdownChange = (key, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [key]: value,
        }));
    };

    const handleProductSelection = (product, index) => {
        if (product.productName) {
            dispatch(batchDropdown({ productId: product._id }))
        }
        const updatedProductList = [...formData.productList];
        updatedProductList[index] = {
            ...updatedProductList[index],
            productId: product._id,
            productName: product.productName,
            hsnCode: product.hsnCode,
            pack: product.salePack,
            mrp: product.mrp,
            gst: product.gst
        };
        setFormData({ ...formData, productList: updatedProductList });
    };

    const addNewRow = () => {
        setFormData((prev) => {
            const updatedList = [
                ...prev.productList,
                {
                    productName: '',
                    hsnCode: '',
                    pack: '',
                    mrp: '',
                    batchNo: '',
                    expDate: '',
                    qty: '',
                    freeQty: '',
                    dnRate: '',
                }
            ];

            const newIndex = updatedList.length - 1;

            setTimeout(() => {
                inputRefs.current[`productDropdown-${newIndex}`]?.click();
            }, 100);

            return {
                ...prev,
                productList: updatedList,
            };
        });

        // Wait for the new row to render
        setTimeout(() => {
            const newIndex = formData.productList.length;
            inputRefs.current[`productDropdown-${newIndex}`]?.click(); // simulate dropdown open
        }, 100);
    };

    const handleDeleteRow = (index) => {
        const updatedProductList = formData.productList.filter((_, i) => i !== index);

        // 1. Update state
        setFormData((prevState) => ({
            ...prevState,
            productList: updatedProductList,
        }));

        // 2. Recalculate values
        calculateAmounts(updatedProductList);
    };


    const parseSafe = (value) => {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    };

    const calculateAmounts = (updatedProductList, discountInput = '', offerInput = '') => {
        const totalBasicAmount = updatedProductList.reduce((total, item) => {
            const mrp = parseSafe(item.mrp);
            const qty = parseSafe(item.qty);
            return total + mrp * qty;
        }, 0);

        const totalGst = updatedProductList.reduce((total, item) => {
            const mrp = parseSafe(item.mrp);
            const qty = parseSafe(item.qty);
            const gstPercent = parseSafe(item.gst);
            const basicAmount = mrp * qty;
            return total + (basicAmount * gstPercent) / 100;
        }, 0);

        const sgst = totalGst / 2;
        const cgst = totalGst / 2;

        const discountValue = parseSafe(discountInput);
        const discountAmount =
            discountInput === ''
                ? 0
                : discountValue <= 100
                    ? (totalBasicAmount * discountValue) / 100
                    : discountValue;

        const offerAmount = offerInput === '' ? 0 : parseSafe(offerInput);

        const intermediateAmount = totalBasicAmount + totalGst - discountAmount - offerAmount;
        const roundedAmount = Math.round(intermediateAmount);
        const roundingDiff = +(roundedAmount - intermediateAmount).toFixed(2);

        setFormData((prev) => ({
            ...prev,
            productList: updatedProductList,
            basicAmount: totalBasicAmount.toFixed(2),
            sgst: sgst.toFixed(2),
            cgst: cgst.toFixed(2),
            roundingAmount: roundingDiff.toFixed(2),
            dnAmount: roundedAmount.toFixed(2),
        }));
    };


    const handleAddReturnBill = (values, { resetForm }) => {
        const payload = {
            partyId: formData.partyId,
            partyName: formData.partyName,
            taxType: formData.taxType,
            dnType: formData.dnType,
            gstApply: formData.gstApply,
            returnDate: formData.returnDate,
            ...formData
        }
        console.log('payload', payload)
        dispatch(addPurchaseReturn(payload, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadteHsn = (values) => {
        const payload = {
            hsnCode: values.hsnCode,
            gst: values.gst,
            igst: values.igst,
            cgst: values.cgst,
            sgst: values.sgst,
        };

        dispatch(updateHsn(payload, limits, ids)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeleteReturnBill = () => {
        dispatch(deletePurchaseReturnBill(ids, limits)).then(() => {
            deleteToggle();
            setMainPage(1);
        });
    };

    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || '',
            page: mainPage,
            limit: rowsPerPage
        };
        setSearchDefault(newSearchParams);
        dispatch(getPurchaseReturnBill(newSearchParams));
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: parseInt(selected.selected) + 1,
            limit: rowsPerPage
        };
        setSearchDefault(updatedSearchParams);
        dispatch(getPurchaseReturnBill(updatedSearchParams));
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        billData?.getpurchaseReturn?.data?.totalCount / postPerPage,
    );

    useEffect(() => {
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: mainPage,
            limit: rowsPerPage
        };
        dispatch(getPurchaseReturnBill(updatedSearchParams));
        dispatch(productDropdown())
        dispatch(partyDropdown())
    }, [mainPage, rowsPerPage]);

    const handleSearchChange = (e) => {
        setSearchProduct(e.target.value.toLowerCase());
    };
    const viewToggle = () => {
        setViewModal(!viewModal);
    };

    const handleView = (pId) => {
        dispatch(viewPurchaseReturnBill(pId));
    };
    const filteredProducts = purchaseData?.productDropdown?.data?.productData?.filter((product) =>
        product.productName.toLowerCase().includes(searchProduct)
    );

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Bill
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className="fw-bold">Purchase Return</h3>
                    <div className='ms-auto border-r me-3 pe-3'>Total Records: <span className='text-success underline underline-offset-2 ps-2'>{billData?.getpurchaseReturn?.data?.totalCount || 0}</span></div>
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Bill No</Th>
                                <Th>Party Name</Th>
                                <Th>Tax Type</Th>
                                <Th>D.N Type</Th>
                                <Th>GST</Th>
                                <Th>Bill Date</Th>
                                <Th>Basic Amount</Th>
                                <Th>SGST</Th>
                                <Th>CGST</Th>
                                <Th>Discount (%)</Th>
                                <Th>Offer Amount (₹)</Th>
                                <Th>Rounding Amount</Th>
                                <Th>Bill Amount</Th>
                                <Th>Remark</Th>
                                <Th className="text-end sticky right-0 bg-white">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                Array.isArray(billData?.getpurchaseReturn?.data?.data) &&
                                    billData?.getpurchaseReturn?.data?.data.length > 0 ? (
                                    billData?.getpurchaseReturn?.data?.data.map((res, index) => (
                                        <Tr key={index}>
                                            <Td className='min-w-[10px]'>{res.returnNumber}</Td>
                                            <Td className='min-w-[10px] capitalize'>{res.partyName}</Td>
                                            <Td className='min-w-[10px]'>{res.taxType}</Td>
                                            <Td className='min-w-[10px]'>{res.dnType}</Td>
                                            <Td className='min-w-[10px]'>{res.gstApply}</Td>
                                            <Td className='min-w-[10px]'>{res.returnDate ? new Date(res.returnDate).toLocaleDateString('en-GB') : ''}</Td>
                                            <Td className='min-w-[50px]'>{res.basicAmount}</Td>
                                            <Td className='min-w-[50px]'>{res.sgst}</Td>
                                            <Td className='min-w-[50px]'>{res.cgst}</Td>
                                            <Td className='min-w-[50px]'>{res.discount}</Td>
                                            <Td className='min-w-[50px]'>{res.otherAmount}</Td>
                                            <Td className='min-w-[50px]'>{res.roundingAmount}</Td>
                                            <Td className='min-w-[50px]'>{res.dnAmount}</Td>
                                            <Td className='min-w-[50px] capitalize'>{res.remark}</Td>
                                            <Td style={{ minWidth: '100px', position: 'sticky', right: '0', backgroundColor: 'white' }}>
                                                <div className="d-flex gap-3 justify-end">
                                                    <VscTarget
                                                        onClick={() => { viewToggle(); handleView(res._id); }}
                                                        className="cursor-pointer text-primary fs-5"
                                                        title="view"
                                                    />
                                                    <FaEdit
                                                        onClick={() => { updateToggle(); setFormData(res); setIds(res._id); }}
                                                        className="cursor-pointer text-success fs-5"
                                                        title="update"
                                                    />
                                                    <MdDelete
                                                        onClick={() => { deleteToggle(); setIds(res._id); }}
                                                        className="cursor-pointer text-danger fs-5"
                                                        title="delete"
                                                    />
                                                </div>
                                            </Td>

                                        </Tr>
                                    ))
                                ) : (
                                    <Tr><Td colSpan={23}>No any data</Td></Tr>
                                )
                            }

                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            {/* add bill */}

            <Modal show={show} onHide={toggle} className='purchase_bill'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Purchase Return</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAddReturnBill}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Party Name</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {formData.partyName || 'Select Party Name'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {
                                                        purchaseData?.partyDropdown?.data?.partyData?.length > 0 ? (
                                                            purchaseData?.partyDropdown?.data?.partyData?.map((res) => {
                                                                return (
                                                                    <Dropdown.Item key={res._id} onClick={() => {
                                                                        handleDropdownChange('partyName', res.partyName);
                                                                        setFormData((prev) => ({
                                                                            ...prev,
                                                                            partyId: res._id,
                                                                        }));
                                                                    }}>{res.partyName}</Dropdown.Item>
                                                                )
                                                            })
                                                        ) : (
                                                            <Dropdown.Item>No any data</Dropdown.Item>
                                                        )
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <ErrorMessage
                                                name="partyName"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tax Type</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {formData.taxType || 'Select Tax Type'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('taxType', 'Inclusive')}>Inclusive</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('taxType', 'Exclusive')}>Exclusive</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>D.N Type</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {formData.dnType || 'Select'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('dnType', 'Debit Note')}>Debit Note</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('dnType', 'Cradit Note')}>Cradit Note</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {formData.gstApply || 'Select'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('gstApply', 'Yes')}>Yes</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('gstApply', 'No')}>No</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bill Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="returnDate"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        returnDate: value,
                                                    }));
                                                }}
                                                value={values.returnDate}
                                                placeholder="Enter HSN Code"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className='col-12'>
                                        <div className='flex justify-end text-2xl text-danger my-3 cursor-pointer' onClick={addNewRow}><FiPlusCircle /></div>
                                        <table className='table table-bordered p-0 purchase_table'>
                                            <thead>
                                                <tr className='text-center text-sm'>
                                                    <th className='min-w-[200px]'>Product Name</th>
                                                    <th className='!min-w-[100px]'>HSN Code</th>
                                                    <th className='!min-w-[50px]'>Pack</th>
                                                    <th className='!min-w-[50px]'>MRP</th>
                                                    <th className='!min-w-[50px]'>Batch</th>
                                                    <th className='!min-w-[50px]'>Expire Date</th>
                                                    <th className='!min-w-[50px]'>Qty</th>
                                                    <th className='!min-w-[50px]'>Free Qty</th>
                                                    <th className='!min-w-[50px]'>D.N Rate</th>
                                                    <th className='!min-w-[50px]'>GST</th>
                                                    <th className='!min-w-[50px]'>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.productList.map((product, index) => (
                                                    <tr key={index} className='text-sm align-middle'>
                                                        <td>
                                                            <Dropdown>
                                                                <Dropdown.Toggle
                                                                    ref={(el) => (inputRefs.current[`productDropdown-${index}`] = el)}
                                                                    className='w-full !text-gray-500 text-start uppercase !text-sm shadow-none border-0 px-0 py-1 bg-transparent'
                                                                    id="dropdown-basic"
                                                                >
                                                                    {product.productName}
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu className='w-[250px] h-[200px] overflow-y-auto'>
                                                                    <div className='text-sm pt-1 px-[16px]'>
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={searchProduct}
                                                                            onChange={handleSearchChange}
                                                                            placeholder='Search product'
                                                                            className='!shadow-none !text-sm focus:!border-theme-dark outline-none focus:!bg-transparent'
                                                                        />
                                                                    </div>
                                                                    {filteredProducts?.length > 0 ? (
                                                                        filteredProducts.map((res) => (
                                                                            <Dropdown.Item
                                                                                className='text-sm uppercase'
                                                                                key={res._id}
                                                                                onClick={() => {
                                                                                    handleProductSelection(res, index);
                                                                                    setTimeout(() => {
                                                                                        inputRefs.current[`mrp-${index}`]?.focus();
                                                                                    }, 100);
                                                                                }}
                                                                            >
                                                                                {res.productName}
                                                                            </Dropdown.Item>
                                                                        ))
                                                                    ) : (
                                                                        <Dropdown.Item>No any data</Dropdown.Item>
                                                                    )}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="hsnCode"
                                                                readOnly
                                                                value={product.hsnCode}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="pack"
                                                                readOnly
                                                                value={product.pack}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="mrp"
                                                                value={product.mrp}
                                                                onChange={(e) => {
                                                                    const updatedList = [...formData.productList];
                                                                    updatedList[index].mrp = e.target.value;
                                                                    setFormData({ ...formData, productList: updatedList });
                                                                    calculateAmounts(updatedList);
                                                                }}
                                                                ref={(el) => (inputRefs.current[`mrp-${index}`] = el)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        inputRefs.current[`batchToggle-${index}`]?.click();
                                                                    }
                                                                }}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>

                                                        <td>
                                                            <Dropdown>
                                                                <Dropdown.Toggle
                                                                    ref={(el) => (inputRefs.current[`batchToggle-${index}`] = el)}
                                                                    className='w-full !text-gray-500 uppercase text-start !text-sm shadow-none border-0 p-0 h-[20px] bg-transparent'
                                                                    id="dropdown-basic"
                                                                >
                                                                    {product?.batchNo || ''}
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu className='w-[350px] h-[200px] overflow-y-auto p-2'>
                                                                    <div className='text-sm flex items-center justify-between border-b'>
                                                                        <div className='col-3'>Batch No</div>
                                                                        <div className='col-4'>Expire Date</div>
                                                                        <div className='col-3'>Qty</div>
                                                                    </div>
                                                                    {dropdown?.batchDropdown?.data?.data?.length > 0 ? (
                                                                        dropdown.batchDropdown.data.data.map((res) => (
                                                                            <div className='w-full !border-b' key={res._id}>
                                                                                <Dropdown.Item
                                                                                    onClick={() => {
                                                                                        const updatedProductList = [...formData.productList];
                                                                                        updatedProductList[index] = {
                                                                                            ...updatedProductList[index],
                                                                                            batchNo: res.batchNumber,
                                                                                            expDate: res.expDate,
                                                                                        };
                                                                                        setFormData({ ...formData, productList: updatedProductList });
                                                                                        setTimeout(() => {
                                                                                            inputRefs.current[`qty-${index}`]?.focus();
                                                                                        }, 100);
                                                                                    }}
                                                                                    className='w-full !flex px-0 items-center justify-between text-sm cursor-pointer'
                                                                                >
                                                                                    <div className='col-3 uppercase'>{res.batchNumber}</div>
                                                                                    <div className='col-4'>
                                                                                        {res.expDate
                                                                                            ? new Date(res.expDate).toLocaleDateString('en-US', {
                                                                                                year: 'numeric',
                                                                                                month: 'long',
                                                                                            })
                                                                                            : ''}
                                                                                    </div>
                                                                                    <div className='col-3'>{res.qty}</div>
                                                                                </Dropdown.Item>
                                                                            </div>
                                                                        ))
                                                                    ) : (
                                                                        <Dropdown.Item>No any data</Dropdown.Item>
                                                                    )}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                type="month"
                                                                name="expDate"
                                                                value={product.expDate ? new Date(product.expDate).toISOString().slice(0, 7) : ''}
                                                                readOnly
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="qty"
                                                                value={product.qty}
                                                                onChange={(e) => {
                                                                    const updatedList = [...formData.productList];
                                                                    updatedList[index].qty = e.target.value;
                                                                    setFormData({ ...formData, productList: updatedList });
                                                                    calculateAmounts(updatedList);
                                                                }}
                                                                ref={(el) => (inputRefs.current[`qty-${index}`] = el)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        inputRefs.current[`freeQty-${index}`]?.focus();
                                                                    }
                                                                }}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="freeQty"
                                                                value={product.freeQty}
                                                                onChange={(e) => {
                                                                    const updatedList = [...formData.productList];
                                                                    updatedList[index].freeQty = e.target.value;
                                                                    setFormData({ ...formData, productList: updatedList });
                                                                }}
                                                                ref={(el) => (inputRefs.current[`freeQty-${index}`] = el)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        inputRefs.current[`dnRate-${index}`]?.focus();
                                                                    }
                                                                }}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>

                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="dnRate"
                                                                value={product.dnRate}
                                                                onChange={(e) => {
                                                                    const updatedList = [...formData.productList];
                                                                    updatedList[index].dnRate = e.target.value;
                                                                    setFormData({ ...formData, productList: updatedList });
                                                                }}
                                                                ref={(el) => (inputRefs.current[`dnRate-${index}`] = el)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        addNewRow();
                                                                        inputRefs.current[`mrp-${index + 1}`]?.focus(); // Go to next row's MRP if needed
                                                                    }
                                                                }}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="gst"
                                                                readOnly
                                                                value={product.gst}
                                                                className='border-0 p-0 shadow-none !text-sm outline-none'
                                                            />
                                                        </td>
                                                        <td className='min-w-[50px]' align='center' onClick={() => handleDeleteRow(index)}>
                                                            <MdOutlineDeleteOutline className='text-danger text-xl cursor-pointer' />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                    </div>

                                    <div className='flex justify-between mt-4'>
                                        <div className='text-sm'>
                                            <div className='flex items-center gap-3 mb-2'>
                                                <div className='w-[100px]'>Remark</div>
                                                <div><Form.Control name='remark' value={formData.remark}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            remark: value,
                                                        }));
                                                    }} type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></div>
                                            </div>
                                        </div>
                                        <table className='text-sm'>
                                            <tr>
                                                <td className='min-w-[200px]'>Basic Amount</td>
                                                <td><Form.Control value={formData.basicAmount} type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>SGST</td>
                                                <td><Form.Control name='sgst' value={formData.sgst} type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>CGST</td>
                                                <td><Form.Control name='cgst' value={formData.cgst} type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Discount Amount(%)</td>
                                                <td><Form.Control value={formData.discount}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            discount: value
                                                        }));
                                                        calculateAmounts(formData.productList, value, formData.otherAmount ?? '');
                                                    }} type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Offer Amount(₹)</td>
                                                <td><Form.Control value={formData.otherAmount}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            otherAmount: value
                                                        }));
                                                        calculateAmounts(formData.productList, formData.discount ?? '', value);
                                                    }} type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Rounding Amount</td>
                                                <td><Form.Control value={formData.roundingAmount}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            roundingAmount: value
                                                        }));
                                                        calculateAmounts(formData.productList);
                                                    }} type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>DN Amount</td>
                                                <td><Form.Control value={formData.dnAmount} type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update Bill */}

            <Modal show={updateModal} onHide={updateToggle} className='purchase_bill'>
                <Modal.Header closeButton>
                    <Modal.Title>Update Purchase Return</Modal.Title>
                </Modal.Header>

                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadteHsn}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Party Name</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {dropdownValues.partyName || 'Select Party Name'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    {
                                                        purchaseData?.partyDropdown?.data?.partyData?.length > 0 ? (
                                                            purchaseData?.partyDropdown?.data?.partyData?.map((res) => {
                                                                return (
                                                                    <Dropdown.Item key={res._id} onClick={() => handleDropdownChange('partyName', res.partyName)}>{res.partyName}</Dropdown.Item>
                                                                )
                                                            })
                                                        ) : (
                                                            <Dropdown.Item>No any data</Dropdown.Item>
                                                        )
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            <ErrorMessage
                                                name="hsnCode"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tax Type</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {dropdownValues.taxType || 'Select Tax Type'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('taxType', 'Inclusive')}>Inclusive</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('taxType', 'Exclusive')}>Exclusive</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>D.N Type</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {dropdownValues.gstApply || 'Select'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('gstApply', 'Yes')}>Yes</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('gstApply', 'No')}>No</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST</Form.Label>
                                            <Dropdown>
                                                <Dropdown.Toggle className='w-full !text-gray-500 text-start shadow-none focus:!border-theme-dark !border-[#dee2e6] py-[6px] px-[12px] bg-transparent' id="dropdown-basic">
                                                    {dropdownValues.invoiceType || 'Select'}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu className='w-full'>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('invoiceType', 'Yes')}>Yes</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => handleDropdownChange('invoiceType', 'No')}>No</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Form.Group>
                                    </div>
                                    <div className="col-2">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Bill Date</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="hsnCode"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('hsnCode', e.target.value)
                                                }
                                                value={values.hsnCode}
                                                placeholder="Enter HSN Code"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="hsnCode"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className='col-12'>
                                        <div className='flex justify-end text-2xl text-danger my-3'><FiPlusCircle /></div>
                                        <table className='table table-bordered p-0 purchase_table'>
                                            <thead>
                                                <tr className='text-center text-sm'>
                                                    <th className='min-w-[200px]'>Product Name</th>
                                                    <th className='!min-w-[100px]'>HSN Code</th>
                                                    <th className='!min-w-[50px]'>Pack</th>
                                                    <th className='!min-w-[50px]'>MRP</th>
                                                    <th className='!min-w-[50px]'>Batch</th>
                                                    <th className='!min-w-[50px]'>Expire Date</th>
                                                    <th className='!min-w-[50px]'>Qty</th>
                                                    <th className='!min-w-[50px]'>Free Qty</th>
                                                    <th className='!min-w-[50px]'>D.N Rate</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className='text-sm align-middle'>
                                                    <td>
                                                        <Dropdown>
                                                            <Dropdown.Toggle className='w-full !text-gray-500 text-start !text-sm shadow-none border-0 px-0 py-1 bg-transparent' id="dropdown-basic">
                                                                {dropdownValues.productName}
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu className='w-full'>
                                                                {
                                                                    purchaseData?.productDropdown?.data?.productData?.length > 0 ? (
                                                                        purchaseData?.productDropdown?.data?.productData?.map((res) => {
                                                                            return (
                                                                                <Dropdown.Item className='text-sm' key={res._id} onClick={() => handleDropdownChange('productName', res.productName)}>{res.productName}</Dropdown.Item>
                                                                            )
                                                                        })
                                                                    ) : (
                                                                        <Dropdown.Item>No any data</Dropdown.Item>
                                                                    )
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                    <td>
                                                        <Dropdown>
                                                            <Dropdown.Toggle className='w-full !text-gray-500 text-start !text-sm shadow-none border-0 px-0 py-1 bg-transparent' id="dropdown-basic">
                                                                {dropdownValues.productName}
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu className='w-full'>
                                                                {
                                                                    purchaseData?.productDropdown?.data?.productData?.length > 0 ? (
                                                                        purchaseData?.productDropdown?.data?.productData?.map((res) => {
                                                                            return (
                                                                                <Dropdown.Item className='text-sm' key={res._id} onClick={() => handleDropdownChange('productName', res.productName)}>{res.productName}</Dropdown.Item>
                                                                            )
                                                                        })
                                                                    ) : (
                                                                        <Dropdown.Item>No any data</Dropdown.Item>
                                                                    )
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            // name="hsnCode"
                                                            as={Form.Control}
                                                            // onChange={(e) => setFieldValue('hsnCode', e.target.value)}
                                                            // value={values.hsnCode}
                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            // name="hsnCode"
                                                            // readOnly
                                                            as={Form.Control}
                                                            // onChange={(e) => setFieldValue('hsnCode', e.target.value)}
                                                            // value={values.hsnCode}
                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            // name="hsnCode"
                                                            // readOnly
                                                            // as={Form.Control}
                                                            // onChange={(e) => setFieldValue('hsnCode', e.target.value)}
                                                            // value={values.hsnCode}
                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="month"
                                                            // name="hsnCode"
                                                            // readOnly
                                                            // as={Form.Control}
                                                            // onChange={(e) => setFieldValue('hsnCode', e.target.value)}
                                                            // value={values.hsnCode}
                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            // name="hsnCode"
                                                            // readOnly
                                                            // as={Form.Control}
                                                            // onChange={(e) => setFieldValue('hsnCode', e.target.value)}
                                                            // value={values.hsnCode}
                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            // name="hsnCode"
                                                            // readOnly
                                                            // as={Form.Control}
                                                            // onChange={(e) => setFieldValue('hsnCode', e.target.value)}
                                                            // value={values.hsnCode}
                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="text"
                                                            // name="hsnCode"
                                                            // readOnly
                                                            // as={Form.Control}
                                                            // onChange={(e) => setFieldValue('hsnCode', e.target.value)}
                                                            // value={values.hsnCode}
                                                            className='border-0 p-0 shadow-none !text-sm outline-none'
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='col-12 bg-gray-300 p-2 mt-4'>
                                        <table className='table table-bordered p-0 mb-0 purchase_table'>
                                            <thead>
                                                <tr className='text-center text-sm'>
                                                    <th className='min-w-[10px]'>SR No.</th>
                                                    <th className='min-w-[200px]'>Product Name</th>
                                                    <th className='!min-w-[100px]'>HSN Code</th>
                                                    <th className='!min-w-[50px]'>Pack</th>
                                                    <th className='!min-w-[50px]'>MRP</th>
                                                    <th className='!min-w-[50px]'>Batch</th>
                                                    <th className='!min-w-[50px]'>Expire Date</th>
                                                    <th className='!min-w-[50px]'>Qty</th>
                                                    <th className='!min-w-[50px]'>Free Qty</th>
                                                    <th className='!min-w-[50px]'>D.N Rate</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    ['1', '2', '3', '4'].map((index) => {
                                                        return (
                                                            <tr className='text-sm align-middle'>
                                                                <td className='min-w-[10px]'>{index}</td>
                                                                <td className='min-w-[100px]'>EPI 1000 Tab</td>
                                                                <td className='min-w-[100px]'>330966</td>
                                                                <td className='min-w-[50px]'>1</td>
                                                                <td className='min-w-[50px]'>250.00</td>
                                                                <td className='min-w-[50px]'>21LK</td>
                                                                <td className='min-w-[50px]'></td>
                                                                <td className='min-w-[50px]'>10</td>
                                                                <td className='min-w-[50px]'>0</td>
                                                                <td className='min-w-[50px]'>154.00</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='flex justify-between mt-4'>
                                        <div className='text-sm'>
                                            <div className='flex items-center gap-3 mb-2'>
                                                <div className='w-[100px]'>Remark</div>
                                                <div><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></div>
                                            </div>
                                        </div>
                                        <table className='text-sm'>
                                            <tr>
                                                <td className='min-w-[200px]'>Basic Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>SGST</td>
                                                <td></td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>CGST</td>
                                                <td></td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Discount Amount</td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Offer Amount</td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>Rounding Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                            <tr>
                                                <td>DN Amount</td>
                                                <td></td>
                                                <td><Form.Control type="text" className='!border-gray-300 p-1 shadow-none !text-sm outline-none' /></td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete Bill */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className="p-5">
                    <div>
                        <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                    </div>
                    <div className="text-center mt-4">
                        <h3>Are You Sure ?</h3>
                        <p className="text-md">
                            Do you really want to delete these records?
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeleteReturnBill}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* view Bill */}
            <Modal show={viewModal} onHide={viewToggle} size='xl'>
                <Modal.Header closeButton>
                    <Modal.Title>Purchase Return Product List</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-5">
                    <div className='table-responsive'>
                        <table className='table table-bordered p-0'>
                            <thead>
                                <tr className='text-center text-sm'>
                                    <th className='min-w-[300px]'>Product Name</th>
                                    <th className='!min-w-[100px]'>HSN Code</th>
                                    <th className='!min-w-[100px]'>Pack</th>
                                    <th className='!min-w-[100px]'>MRP</th>
                                    <th className='!min-w-[100px]'>Batch No</th>
                                    <th className='!min-w-[100px]'>Expire Date</th>
                                    <th className='!min-w-[100px]'>Qty</th>
                                    <th className='!min-w-[100px]'>Free Qty</th>
                                    <th className='!min-w-[100px]'>DN Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    billData?.viewpurchaseReturn?.data?.data?.productList?.length > 0 ? (
                                        billData.viewpurchaseReturn.data.data.productList.map((res, index) => (
                                            <tr key={index}>
                                                <td className='uppercase'>{res.productName}</td>
                                                <td>{res.hsnCode}</td>
                                                <td className='uppercase'>{res.pack}</td>
                                                <td>{res.mrp}</td>
                                                <td>{res.batchNo}</td>
                                                <td>{new Date(res?.expDate).toLocaleDateString('en-GB', { month: '2-digit', year: 'numeric' })}</td>
                                                <td>{res.qty}</td>
                                                <td>{res.freeQty || '-'}</td>
                                                <td>{res.dnRate || '-'}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={9} className="text-center">No data available</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
}
